import { Box, FormControl, FormLabel, Switch, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SourcingEventPatchDto } from "../../../../../../autogen/bff-api";

interface Props {
  usesEspd: boolean;
  partIV?: boolean;
  utilitiesPartIII?: boolean;
  onChange: (patch: SourcingEventPatchDto) => void;
}

export const EspdChoiceField = ({ usesEspd, partIV = false, utilitiesPartIII = false, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Box borderWidth="1px" borderColor="smBorder" borderRadius="lg" bg="white" p="5" mt="10">
      <FormControl display="flex" alignItems="flex-start" justifyContent="space-between" gap="6">
        <Box>
          <FormLabel htmlFor="espdEnabled" mb="1" cursor="pointer">
            <Text fontSize="sm" fontWeight="semibold">
              {t("Use ESPD (European Single Procurement Document)")}
            </Text>
          </FormLabel>
          <Text fontSize="sm" color="smMuted">
            {usesEspd
              ? t("Suppliers fill in the ESPD, and you choose the exclusion grounds below.")
              : utilitiesPartIII
                ? t(
                    "A procurement under forsyningsforskriften del III does not require the ESPD. Without it, state the exclusion grounds and how suppliers document them in the procurement documents.",
                  )
                : partIV
                ? t(
                    "An FOA Part IV procurement does not require the ESPD. Without it, state the exclusion grounds and how suppliers document them in the procurement documents.",
                  )
                : t(
                    "An FOA Part II procurement does not require the ESPD. Without it, state the exclusion grounds and how suppliers document them in the procurement documents.",
                  )}
          </Text>
        </Box>
        <Switch
          id="espdEnabled"
          isChecked={usesEspd}
          onChange={(e) => onChange({ publicContext: { espdEnabled: e.target.checked } })}
          colorScheme="teal"
          mt="1"
        />
      </FormControl>
    </Box>
  );
};
